"use client";
import useDOMEventListener from "@/hooks/useDOMEventListener";
import { createQueryStrings } from "@knowt/syncing/utils/genericUtils";
import Fade from "@mui/material/Fade";
import Slide from "@mui/material/Slide";
import { useRouter } from "@bprogress/next";
import { useState } from "react";
import ChangeAuthDetailsPage, { ChangeAuthDetailsType } from "../ChangeAuthDetailsPage/ChangeAuthDetailsPage";
import LoginPage from "../LoginPage/LoginPage";
import ResetPage from "../ResetPage/ResetPage";
import SignUpPage from "../SignupPage/SignupPage";
import VerifyPage from "../VerifyPage/VerifyPage";
import { useAuthSlideContextSelector } from "./hook/useAuthSlideContext";

const AuthSlideDialog = () => {
    const router = useRouter();
    const [bg, setBg] = useState("transparent"); // custom bg just to make fade animation looks better IMO

    const authSlideStates = useAuthSlideContextSelector(state => state.authSlideStates);
    const openAuthSlide = useAuthSlideContextSelector(state => state.openAuthSlide);
    const closeAuthSlide = useAuthSlideContextSelector(state => state.closeAuthSlide);
    const event = authSlideStates.event;

    const {
        showLoginPage,
        showResetPage,
        showVerifyPage,
        showSignupPage,
        showEmailChangePage,
        showUsernameChangePage,
        isOpen,
        extra: authSlideAdditionalProps,
    } = authSlideStates;

    const onClose = () => {
        authSlideAdditionalProps?.onClose?.();
        closeAuthSlide();
    };

    useDOMEventListener({
        on: "keydown",
        handler: event => {
            if (event.key === "Escape") {
                closeAuthSlide();
            }
        },
    });

    const Content = () =>
        showVerifyPage ? (
            <VerifyPage
                onLoadVerifyError={closeAuthSlide}
                onVerified={async () => {
                    onClose();
                }}
            />
        ) : showResetPage ? (
            <ResetPage
                onReset={() => {
                    router.push("/login");
                    openAuthSlide({ event, showLoginPage: true });
                }}
            />
        ) : showLoginPage ? (
            <LoginPage prefilledEmail={authSlideAdditionalProps?.prefilledEmail || ""} onClose={onClose} />
        ) : showSignupPage ? (
            <SignUpPage
                event={authSlideStates.event}
                onClose={onClose}
                onSignUp={username => {
                    router.push(`/verify${createQueryStrings({ username, fromSignup: true })}`);
                    openAuthSlide({ event, showVerifyPage: true });
                }}
            />
        ) : showEmailChangePage ? (
            <ChangeAuthDetailsPage
                onSubmit={async () => {
                    setTimeout(() => closeAuthSlide(), 1000);
                }}
                onClose={onClose}
                type={ChangeAuthDetailsType.EMAIL}
            />
        ) : showUsernameChangePage ? (
            <ChangeAuthDetailsPage
                onSubmit={async () => {
                    setTimeout(() => closeAuthSlide(), 1000);
                }}
                onClose={onClose}
                type={ChangeAuthDetailsType.USERNAME}
            />
        ) : (
            <div style={{ height: "50vh", background: "red", textAlign: "center" }}>
                NO PAGE BEING PASSED TO AuthSlideDialog!!!
            </div>
        );

    return (
        <Slide in={isOpen} direction="down" unmountOnExit mountOnEnter timeout={300} onExited={() => closeAuthSlide()}>
            <div style={{ position: "fixed", top: 0, left: 0, right: 0, backgroundColor: bg, zIndex: 1550 }}>
                <div className="authSlideWrapper" style={{ position: "relative" }}>
                    <Fade
                        in={isOpen}
                        timeout={isOpen ? 400 : 200}
                        onEnter={() => setBg(bg)}
                        onExit={() => setTimeout(() => setBg("transparent"), 100)}>
                        <div className="authFaceWrapper">{Content()}</div>
                    </Fade>
                </div>
            </div>
        </Slide>
    );
};

export default AuthSlideDialog;
